import { Vue, Component } from 'vue-property-decorator'
import ArticuloList from '@/components/ArticuloList.vue'
import catalogos from '@/store/modules/CatalogoModule'
import marcas from '@/store/modules/MarcaModule'
import AppBar from '@/components/AppBar.vue'

import articulos from '@/store/modules/ArticuloModule'

@Component({
  components: {
    ArticuloList,
    AppBar
  }
})
export default class PrincipalPage extends Vue {
  loading = false
  marcasSelected: string[] = []
  catalogosSelected: string[] = []
  searchCatalogo = ''
  openCatalogo = false
  openMarca = false

  get catalogos () {
    return catalogos.items
  }

  get marcas () {
    return marcas.items
  }

  get catalogosFilter () {
    return this.catalogos.filter(item => {
      if (this.searchCatalogo === null) return true
      if (this.searchCatalogo.length === 0) return true
      if (item.nombre.indexOf(this.searchCatalogo.toUpperCase()) > -1) return true
      return false
    })
  }

  get marcasFilter () {
    return this.marcas.filter(item => {
      if (this.searchCatalogo === null) return true
      if (this.searchCatalogo.length === 0) return true
      if (item.nombre.indexOf(this.searchCatalogo.toUpperCase()) > -1) return true
      return false
    }).filter(item => {
      if (this.catalogosSelected.length === 0) return true
      return this.catalogosSelected.filter(value => item.catalogos.includes(value)).length > 0
    })
  }

  get titleCatalogos () {
    return this.catalogosSelected.reduce((accum, value) => {
      const catalogo = this.catalogos.find(item => item.codigo_sistema === value)
      return accum + ' | ' + catalogo?.nombre
    }, '')
  }

  get titleMarcas () {
    return this.marcasSelected.reduce((accum, value) => {
      const marca = this.marcas.find(item => item.codigo_sistema === value)
      return accum + ' | ' + marca?.nombre
    }, '')
  }

  mounted () {
    catalogos.fetchAll()
    marcas.fetchAll()
    this.onLoadArticulos()
  }

  get articulos () {
    return articulos.items
  }

  onClickCatalogo (id: string) {
    this.marcasSelected = []
    this.openCatalogo = false
    this.openMarca = true
    if (this.catalogosSelected.filter(item => item === id).length === 0) {
      this.catalogosSelected = [...this.catalogosSelected, id]
    } else {
      this.catalogosSelected = this.catalogosSelected.filter(item => item !== id)
    }

    this.onLoadArticulos()
  }

  onClickMarca (id: string) {
    if (this.marcasSelected.filter(item => item === id).length === 0) {
      this.marcasSelected = [...this.marcasSelected, id]
    } else {
      this.marcasSelected = this.marcasSelected.filter(item => item !== id)
    }
    this.onLoadArticulos()
  }

  onLoadArticulos () {
    const filtroMarcas = this.marcasSelected.length === 0 ? '' : 'marcas[]=' + this.marcasSelected.join('&marcas[]=')
    let filtroLineas = this.catalogosSelected.length === 0 ? '' : 'catalogos[]=' + this.catalogosSelected.join('&catalogos[]=')
    filtroLineas = this.marcasSelected.length === 0 ? filtroLineas : '&' + filtroLineas
    this.loading = true
    articulos.fetchAll(filtroMarcas + filtroLineas).finally(() => (this.loading = false))
  }
}
